import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ConvexReactClient } from 'convex/react';
import { ConvexAuthProvider } from '@convex-dev/auth/react';
import './index.css';
import App from './App';

const convexUrl = import.meta.env.VITE_CONVEX_URL;
if (!convexUrl) {
  throw new Error(
    'Falta VITE_CONVEX_URL. Ejecuta `npx convex dev` (genera el .env.local) y reinicia el server.'
  );
}

const convex = new ConvexReactClient(convexUrl);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No se encontró #root en index.html');

createRoot(rootEl).render(
  <StrictMode>
    <ConvexAuthProvider client={convex}>
      <App />
    </ConvexAuthProvider>
  </StrictMode>
);
